export const filterConditionNotequalIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M15.384 2.531h-1.922L10.959 7H2.571v1.49h7.538l-1.668 2.979h-5.87v1.49h5.036l-2.518 4.469h1.922l2.518-4.469h7.94v-1.49h-7.106l1.668-2.979h5.438V7h-4.588z"/></svg>`,
  name: 'filter-condition-notequal',
};
